"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.egiftCardProductType = void 0;
const core_attributes_1 = require("./core-attributes");
const variant_attributes_1 = require("./variant-attributes");
const common_1 = require("./common");
exports.egiftCardProductType = {
    name: 'E-Gift Card',
    key: common_1.ProductTypesEnum.EGIFT_CARD,
    description: 'E-Gift Card',
    attributes: [
        core_attributes_1.styleCode,
        core_attributes_1.styleName,
        core_attributes_1.productType,
        core_attributes_1.productSubType,
        core_attributes_1.featureDescription,
        core_attributes_1.vertexTaxGroup,
        variant_attributes_1.priceDenomination,
        variant_attributes_1.ean,
        variant_attributes_1.upc,
        variant_attributes_1.occasion,
        core_attributes_1.newCommodityCode,
    ],
};
//# sourceMappingURL=egift-card.js.map